export default {
    Catalogue(state, catalogue) {
        state.catalogue.push(catalogue)
    },
    Renseignement(state, renseignement) {
        state.renseignements = []
        state.renseignements.push(renseignement)
    }
}